import React from 'react';
import { useLocation } from 'react-router-dom';
import NavBar from '../../Navigation/NavBar';
import Footer from '../LandingPage/Footer';
import { useMediaQuery } from "@mui/material";

function BlogDetail() {
  const isXs = useMediaQuery('(min-width:600px) and (max-width:3000px)');
  const location = useLocation();
  const { state: blogData } = location;

  if (!blogData) {
    return <div>No blog data found.</div>;
  }

  return (
    <>
      <NavBar />
      <div style={{ padding: isXs ?  '5rem 6rem':'3rem 1.5rem' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <img
            style={{ height: isXs ?  '400px':'200px', width: '100%' }}
            src={blogData.postFile}
            alt="Blogdetailimage"
          />
          <div style={{ display: 'flex', padding: '0px 0px' }}>
              <div style={{ color: '#CB8B65', textTransform: 'uppercase', fontWeight: 'bold' }}>{blogData.postCategory}</div>&nbsp; /
              <div>&nbsp;{blogData.postDate}</div>
            </div>
          <div style={{ fontSize: '32px', fontWeight: '500' }}>
            {blogData.postTitle}
          </div>
          <div dangerouslySetInnerHTML={{ __html: blogData.postDescription }}
             style={{marginTop: '20px',  marginBottom:'120px'}}>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default BlogDetail;
